<div class="row mt-2">
  <div class="col d-flex justify-content-end gap-2">

    <div class="context-selector" *ngIf="!authService.isOperatoreUvm && !authService.isOperatoreUvcp">  
      <it-dropdown [color]="selectedContext.value === 'ALL' ? 'primary' : 'danger'" dark="true" style="min-width: 200px;">
        <span button>{{ selectedContext.label }}</span>
        <ng-container list>
          <it-dropdown-item
            *ngFor="let item of searchContexts"
            (click)="onContextChange(item)"
            [active]="item.value === selectedContext.value"
          >
            {{ item.label }}
          </it-dropdown-item>
        </ng-container>
      </it-dropdown>
    </div>

    <button itButton="primary" 
      [size]="'xs'" 
      [disabled]="isReloading"
      (click)="loadStats()">
      <it-icon name="refresh" color="white" class="me-2" size="xs"></it-icon> Ricarica dati
    </button>

    <button *ngIf="!authService.isOperatoreUvm && !authService.isOperatoreUvcp && !authService.isOperatoreSuperUser"
      itButton="success"
      [size]="'sm'"
      [routerLink]="['/request-new']"
    >
      <it-icon name="plus" [color]="'white'"></it-icon> Nuova richiesta
    </button>

  </div>
</div>


<div class="row mt-2" *ngIf="!authService.isOperatoreUvm && !authService.isOperatoreUvcp && !authService.isOperatoreSuperUser">
  <div class="col-12 col-md-6 col-lg-6 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalToComplete"
        title="DA COMPLETARE"
        [links]="[
          {
            label: 'Visualizza tutte',
            route: '/request-list',
            queryParams: {
              statusCodes: ['BOZ','APE'],
              withPastUserOwnership: true,
              withCurrentUserOwnership: true
            }
          }
        ]"
      ></app-dashboard-card>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-6 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalToManage"
        title="IN GESTIONE"
        [links]="linksToManage"
      ></app-dashboard-card>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-6 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalUvmSol"
        title="IN VALUTAZIONE"
        [links]="linksSol"
      ></app-dashboard-card>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-6 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalClosed"
        title="CHIUSE"
        bgColor="success"
        [links]="linksClosed"
      ></app-dashboard-card>
    </div>
  </div>
</div>

<div class="row mt-2" *ngIf="authService.isOperatoreSuperUser">
  <div class="col-12 col-md-6 col-lg-6 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalToComplete"
        title="DA COMPLETARE"
        [links]="[
          {
            label: 'Visualizza tutte',
            route: '/request-list',
            queryParams: {
              statusCodes: ['BOZ','APE']
            }
          }
        ]"
      ></app-dashboard-card>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-6 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalToManage"
        title="IN GESTIONE"
        [links]="linksToManage"
      ></app-dashboard-card>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-6 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalUvmSol"
        title="IN VALUTAZIONE"
        [links]="linksSol"
      ></app-dashboard-card>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-6 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalClosed"
        title="CHIUSE"
        bgColor="success"
        [links]="linksClosed"
      ></app-dashboard-card>
    </div>
  </div>
</div>

<div class="row mt-2" *ngIf="authService.isOperatoreUvm">
  <div class="col-12 col-md-4 col-lg-4 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalToComplete"
        title="DA VALUTARE"
        bgColor="warning"
        [links]="[
          {
            label: 'Visualizza tutte',
            route: '/request-list',
            queryParams: {
              statusCodes: ['PIC', 'NEW', 'CP', 'CS','TPV'],
              withPastUserOwnership: false,
              withCurrentUserOwnership: true,
              isTransitionUvm: true,
              isUvmFilled: false
            }
          }
        ]"
      ></app-dashboard-card>
    </div>
  </div>
    <div class="col-12 col-md-4 col-lg-4 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalUvmSol"
        title="IN VALUTAZIONE"
        [links]="linksSol"
      ></app-dashboard-card>
    </div>
  </div>
  <div class="col-12 col-md-4 col-lg-4 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalClosed"
        title="VALUTATE"
        [links]="[
          {
            label: 'Visualizza tutte',
            route: '/request-list',
            queryParams: {
              statusCodes: ['PIC', 'NEW', 'CP', 'CS','DAT','TPV','VAL','CPZ','CST', 'DEL', 'END','CHI'],
              withPastUserOwnership: true,
              withCurrentUserOwnership: true,
              isTransitionUvm: true,
              isUvmFilled: true
            }
          }
        ]"
      ></app-dashboard-card>
    </div>
  </div>
</div>

<div class="row mt-2" *ngIf="authService.isOperatoreUvcp">
  <div class="col-12 col-md-4 col-lg-4 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalToComplete"
        title="DA VALUTARE"
        bgColor="warning"
        [links]="[
          {
            label: 'Visualizza tutte',
            route: '/request-list',
            queryParams: {
              statusCodes: ['TPV'],
              withPastUserOwnership: false,
              withCurrentUserOwnership: true,
            }
          }
        ]"
      ></app-dashboard-card>
    </div>
  </div>
    <div class="col-12 col-md-4 col-lg-4 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalUvmSol"
        title="IN VALUTAZIONE"
        [links]="linksSol"
      ></app-dashboard-card>
    </div>
  </div>
  <div class="col-12 col-md-4 col-lg-4 mb-2">
    <div class="border-0">
      <app-dashboard-card
        [total]="totalClosed"
        title="VALUTATE"
        [links]="[
          {
            label: 'Visualizza tutte',
            route: '/request-list',
            queryParams: {
              statusCodes: ['VAL','CPZ','CST', 'DEL', 'END','CHI'],
              withPastUserOwnership: true,
              withCurrentUserOwnership: true,
              isTransitionUvm: true,
            }
          }
        ]"
      ></app-dashboard-card>
    </div>
  </div>
</div>

<div class="row mt-2" *ngIf="ownRequest?.length && !authService.isOperatoreSuperUser">
  <div class="col">
    <div class="card-wrapper">
      <it-card background="true">
        <h4 class="card-title h4">Pratiche di competenza più recenti</h4>
        <app-own-requests [ownRequest]="ownRequest"></app-own-requests>
      </it-card>
    </div>
  </div>
</div>

<div class="row mt-2">
  <div class="col-8">
    <div class="card-wrapper" *ngIf="!authService.isOperatoreSuperUser">
      <it-card background="true">
        <h4 class="card-title h4" *ngIf="!authService.isOperatoreUvm && !authService.isOperatoreUvcp">
          Pratiche da completare
        </h4>
        <h4 class="card-title h4" *ngIf="authService.isOperatoreUvm || authService.isOperatoreUvcp">
          Pratiche da valutare
        </h4>
        <app-request-carousel
          [requestToComplete]="requestsToComplete"
        ></app-request-carousel>
      </it-card>
    </div>
  </div>
  <div class="col-4">
    <div class="card-wrapper">
      <it-card background="true">
        <h4 class="card-title h4">Ricerca rapida</h4>
        <app-rapid-search></app-rapid-search>
      </it-card>
    </div>
  </div>
</div>
